var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgPattern3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 212,
    viewBox: "0 0 221 212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#44FFA1",
    transform: "rotate(-145 104.244 83.528)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 68.5,
    rx: 34,
    ry: 68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5,
    cy: 68.5,
    rx: 34,
    ry: 68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86,
    cy: 68.5,
    opacity: 0.75,
    rx: 33.5,
    ry: 68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.5,
    cy: 68.5,
    opacity: 0.5,
    rx: 34,
    ry: 68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 139,
    cy: 68.5,
    opacity: 0.25,
    rx: 33.5,
    ry: 68
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern3);
export default __webpack_public_path__ + "static/media/bg-pattern-3.60897e39e078db73af9ebc8159ab0deb.svg";
export { ForwardRef as ReactComponent };